import React from "react";
import "./Page5.css";
import people from "../../assets/img.png";
import foundation1 from "../../assets/foundation1.jpg"
import cloud from "../../assets/cloud.webp"

const Page5 = () => {
  return (
    <div className="p5-div">
      <div className="p5">
        <div className="p5-head">
          <h2>
            OUR <b>SOLUTION</b>
          </h2>
          <p>
            RPTN are always there to find modern solution on modern problems{" "}
            <br /> based on innovative technologies
          </p>
        </div>
      </div>
      <div className="p5-card">
        <div className="p5-card1">
          <div className="p5-card2 p51">
            <img src={people} alt="" width="120px"/>
            <h2><b>APPROACH</b></h2>
          </div>
          <div className="p5-card2 p52">
          <img src={foundation1} alt="" width="120px"/>
            <h2><b>Foundation</b></h2>
          </div>
        </div>
        <div className="p5-card1">
          <div className="p5-card21 p53">
            <h3>TRANSMIGRATE</h3>
            <p>
              We enable businesses to rethink their transition strategy so that
              they may implement a model for all apps that has little disruption
              when migrating to public and hybrid cloud environments using a
              'factory' approach.
            </p>
          </div>
          <div className="p5-card2 p54">
            <img src={cloud} alt="" width="120px"/>
            <h2><b>Cloud Security</b></h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Page5;
